import { type FC, type ReactNode } from "react";

import { MenuButton as HeadlessUIMenuButton } from "@headlessui/react";

// Compact bordered dropdown trigger with a chevron. Sibling to MenuButton
// (which uses the Button color/size system). Intended for inline filter
// menus where the full Button chrome would feel heavy.
const Chevron: FC = () => (
  <svg
    aria-hidden="true"
    viewBox="0 0 12 12"
    fill="none"
    className="size-3 text-slate-400"
  >
    <path
      d="M3 4.5L6 7.5L9 4.5"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const MenuTrigger: FC<{ children: ReactNode }> = ({ children }) => (
  <HeadlessUIMenuButton className="inline-flex items-center gap-1.5 rounded-md border border-slate-200 bg-white px-3 py-1.5 text-xs font-medium text-slate-700">
    <span>{children}</span>
    <Chevron />
  </HeadlessUIMenuButton>
);
